// extracted by mini-css-extract-plugin
module.exports = {"noScrolling":"LeaderboardNavigation_noScrolling__B1N51","arrow":"LeaderboardNavigation_arrow__6Kryt","previous":"LeaderboardNavigation_previous__cSiIJ"};